var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link as RouterLink, useLocation, useNavigate, useParams, } from 'react-router-dom';
import Alert from '@storeblocks/alert';
import LoadingIndicator from '@storeblocks/loading-indicator';
import { getText } from '@storebrand-digital/fms-translations';
import Box from '@storeblocks/box';
import Heading from '../../components/Heading';
import AllAttachments from './AllAttachments';
import Bubble from './Bubble';
import ReplyBox from './ReplyBox';
import { formatDateTime } from '../Inbox/Items';
import ErrorComponent from '../../components/ErrorComponent';
import { getNotificationsRequested, getMessageThreadRequested, getMessagesRequested, markMessageAsReadRequested, markNotificationsAsReadRequested, } from './redux/messageThreadSlice';
import { AlertWrap, SpinnerWrap, ChatBase, Container, Wrap, AlertButton, } from './styled';
function Chat() {
    var id = useParams().id;
    var search = useLocation().search;
    var navigate = useNavigate();
    var dispatch = useDispatch();
    var _a = useState(0), offset = _a[0], setOffset = _a[1];
    useEffect(function () {
        dispatch(getNotificationsRequested());
    }, []);
    var _b = useSelector(function (state) { return state.messageThread; }), _c = _b.getMessageThread, loading = _c.loading, error = _c.error, _d = _b.getMessages, messagesLoading = _d.loading, getMessagesError = _d.error, _e = _b.getEvents, eventsLoading = _e.loading, events = _e.events, messageThread = _b.messageThread, totalMessageCount = _b.totalMessageCount, records = _b.records;
    useEffect(function () {
        if (offset === 0) {
            dispatch(getMessageThreadRequested({ threadId: id }));
        }
        else {
            dispatch(getMessagesRequested({ threadId: id, limit: 20, offset: offset }));
        }
    }, [offset]);
    useEffect(function () {
        if (!loading || !messagesLoading) {
            var recordIdsToBeMarkedAsRead = records === null || records === void 0 ? void 0 : records.filter(function (record) { return !record.isRead && record.isFromAdvisor; }).map(function (rec) { return rec.id; });
            if (recordIdsToBeMarkedAsRead && recordIdsToBeMarkedAsRead.length > 0) {
                var payload = { threadId: id, messageIds: recordIdsToBeMarkedAsRead };
                dispatch(markMessageAsReadRequested(payload));
            }
        }
    }, [loading]);
    useEffect(function () {
        if (records && records.length > 0) {
            var sentNrOfMessages = records.filter(function (record) { return record.type === 'Inbound'; }).length;
            var receivedNrOfMessages = records.filter(function (record) { return record.type === 'Outbound'; }).length;
            var caseDescription = messageThread === null || messageThread === void 0 ? void 0 : messageThread.relatedCase.subject;
            window.dataLayer.push({
                event: 'universal-event',
                eventModel: {
                    event_category: 'smessagescount',
                    event_action: "".concat(sentNrOfMessages, "&").concat(receivedNrOfMessages),
                    event_label: "".concat(id),
                    event_extension: "".concat(caseDescription),
                },
            });
        }
    }, [records]);
    useEffect(function () {
        if (!loading || !messagesLoading) {
            var elementId = "#task-".concat(totalMessageCount - 1);
            if (offset === 0) {
                elementId = "#task-".concat(records ? records.length - 1 : 0);
            }
            var current = document.querySelector(elementId);
            if (current) {
                current.scrollIntoView();
            }
        }
    }, [loading]);
    // eslint-disable-next-line consistent-return
    useEffect(function () {
        var lastCase = document.querySelector('body');
        if (lastCase) {
            var observer_1 = new IntersectionObserver(function (_a) {
                var e = _a[0];
                if (e.isIntersecting && totalMessageCount === 20 && !loading) {
                    setOffset(records.length);
                }
            }, {
                threshold: 1,
            });
            observer_1.observe(lastCase);
            return function () { return observer_1.unobserve(lastCase); };
        }
    }, [records]);
    useEffect(function () {
        if (!eventsLoading) {
            events
                .filter(function (event) { return event.url.includes(id) && !event.isRead; })
                .forEach(function (unreadEvent) {
                dispatch(markNotificationsAsReadRequested(unreadEvent.id));
            });
        }
    }, [eventsLoading]);
    useEffect(function () {
        var _a;
        if (((_a = error === null || error === void 0 ? void 0 : error.response) === null || _a === void 0 ? void 0 : _a.status) === 418) {
            navigate('/meldinger');
        }
    }, [error, id]);
    var onChatStart = function () {
        if (window.chatPanel) {
            window.chatPanel.show();
        }
    };
    function renderHeading() {
        var caseDescription = messageThread === null || messageThread === void 0 ? void 0 : messageThread.relatedCase.subject;
        var title = caseDescription
            ? "".concat(caseDescription, " ref ").concat(messageThread === null || messageThread === void 0 ? void 0 : messageThread.relatedCase.number)
            : ' ';
        return (React.createElement(Heading, { title: title },
            React.createElement("a", { href: getText('breadcrumb.overview.href') }, getText('breadcrumb.overview.title')),
            React.createElement(RouterLink, { to: "".concat(getText('breadcrumb.messages.href')).concat(search) }, getText('breadcrumb.messages.title')),
            React.createElement(RouterLink, { to: "".concat(getText('breadcrumb.messages.href')).concat(id) }, messageThread === null || messageThread === void 0 ? void 0 : messageThread.relatedCase.number)));
    }
    function renderMessages() {
        if (error || getMessagesError) {
            return (React.createElement(AlertWrap, null,
                React.createElement(ErrorComponent, { error: error || getMessagesError })));
        }
        if ((records === null || records === void 0 ? void 0 : records.length) === 0) {
            return (React.createElement(AlertWrap, null,
                React.createElement(Alert, { title: getText('chat.messages.empty'), variant: "info", fluid: true })));
        }
        var reversed = __spreadArray([], (records || []), true).reverse();
        return (React.createElement(React.Fragment, null, reversed.map(function (record, index) { return (React.createElement(Bubble, { key: record.id, id: "task-".concat(index), "$right": !record.isFromAdvisor, name: record.isFromAdvisor
                ? getText('chat.advisor')
                : getText('chat.customer'), taskId: record.id, time: formatDateTime(record.createdDate), content: record.body, attachments: record.files })); })));
    }
    function renderReplyBox() {
        var _a;
        if (((_a = messageThread === null || messageThread === void 0 ? void 0 : messageThread.relatedCase.status) === null || _a === void 0 ? void 0 : _a.caseStatus) === 'CLOSED') {
            return (React.createElement(Box, { mt: "40px" },
                React.createElement(Alert, { title: getText('compose.archived.reply.title'), fluid: true },
                    React.createElement("div", null,
                        getText('compose.archived.reply.description'),
                        React.createElement(AlertButton, { onClick: onChatStart }, getText('compose.archived.reply.link.label'))))));
        }
        return React.createElement(ReplyBox, null);
    }
    return (React.createElement(Wrap, null,
        renderHeading(),
        React.createElement(Container, null,
            React.createElement(AllAttachments, null)),
        loading ? (React.createElement(SpinnerWrap, null,
            React.createElement(LoadingIndicator, null))) : (React.createElement(ChatBase, null,
            renderMessages(),
            messageThread && !error && renderReplyBox()))));
}
export default Chat;
